import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

const supabaseUrlFunctions = process.env.NEXT_PUBLIC_SUPABASE_URL_FUNCTIONS!;
const supabaseAnonKeyFunctions =
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY_FUNCTIONS!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const supabaseFunctions = createClient(
  supabaseUrlFunctions,
  supabaseAnonKeyFunctions
);
